import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeartChecked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 18,
	viewBox: "0 0 22 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 18L6.825 15.15C5.625 14.0667 4.59583 13.1 3.7375 12.25C2.87917 11.4 2.17083 10.6 1.6125 9.85C1.05417 9.1 0.645833 8.375 0.3875 7.675C0.129167 6.975 0 6.24167 0 5.475C0 3.90833 0.525 2.60417 1.575 1.5625C2.625 0.520833 3.93333 0 5.5 0C6.36667 0 7.19167 0.179167 7.975 0.5375C8.75833 0.895833 9.43333 1.40833 10 2.075C10.5667 1.40833 11.2417 0.895833 12.025 0.5375C12.8083 0.179167 13.6333 0 14.5 0C15.9167 0 17.1042 0.429167 18.0625 1.2875C19.0208 2.14583 19.6167 3.15 19.85 4.3C19.5167 4.16667 19.1667 4.08333 18.8 4.05C18.4333 4.01667 18.0583 4 17.675 4C16.2583 4 14.9583 4.57083 13.775 5.7125C12.5917 6.85417 12 8.28333 12 10C12 10.8 12.175 11.6125 12.525 12.4375C12.875 13.2625 13.3667 13.9333 14 14.45C13.6833 14.7333 13.2708 15.0958 12.7625 15.5375C12.2542 15.9792 11.8167 16.3667 11.45 16.7L10 18ZM16.95 13.175L14.1 10.35L15.525 8.95L16.95 10.35L20.475 6.825L21.9 8.225L16.95 13.175Z",
		fill: "current"
	})
});
export default SvgHeartChecked;
